module.exports = __webpack_public_path__ + "img/lock.638a0637.svg";